@use "@fukuri-admins/ui/layout" as *;

.container {
  display: grid;
  min-height: 400px;
  padding: spacing("24");
  border-radius: borderRadius("lg");
  border: 1px solid border("Tertiary");
}

.illustration {
  border-radius: 40px;
}

.message {
  color: text("Middle");
  @include typography("Jp/16_W3");
}
